import { push } from '@takeshape/redux-little-router';
import { showMessage } from 'app/messages/actions';
import { getSelected, initMultiSelect } from 'app/multi-select';
import { all, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { getRoutineSaga } from '../common/utils/saga.js';
import { getProjectPath } from '../project/index.js';
import { createApiKey, deleteApiKey, deleteSelectedApiKeys, getApiKeys } from './actions.js';
import { createApiKeyMutation, deleteApiKeyMutation, getApiKeysQuery } from './api.js';
import { NAME } from './constants.js';

export function* initApiKeyMultiSelect({ payload }) {
  const ids = payload.apiKeys.map((key) => key.id);
  yield put(initMultiSelect({ multiSelectName: NAME })(ids));
}

export function* deleteSelectedApiKeysSaga() {
  const selected = yield select(getSelected, { multiSelectName: NAME });
  for (const id of selected) {
    yield put(deleteApiKey({ id }));
  }
}

export function* refetchApiKeysSaga() {
  yield put(getApiKeys());
  const projectPath = yield select(getProjectPath);
  const redirectUrl = `${projectPath}/api-keys`;
  yield put(push(redirectUrl));
}

export function* showCreationFailureSaga() {
  yield put(showMessage('error', 'API Key creation failed, please try again.', 3000));
}

export const deleteApiKeySaga = getRoutineSaga(deleteApiKey, deleteApiKeyMutation);
export const getApiKeysSaga = getRoutineSaga(getApiKeys, getApiKeysQuery);
export const createApiKeySaga = getRoutineSaga(createApiKey, createApiKeyMutation);

export default function* root() {
  yield all([
    takeEvery(getApiKeys.REQUESTED, getApiKeysSaga),
    takeEvery(getApiKeys.FULFILLED, initApiKeyMultiSelect),
    takeEvery(deleteApiKey.REQUESTED, deleteApiKeySaga),
    takeLatest(deleteApiKey.FULFILLED, refetchApiKeysSaga),
    takeEvery(deleteSelectedApiKeys, deleteSelectedApiKeysSaga),
    takeEvery(createApiKey.REQUESTED, createApiKeySaga),
    takeLatest(createApiKey.FULFILLED, refetchApiKeysSaga),
    takeLatest(createApiKey.REJECTED, showCreationFailureSaga)
  ]);
}
